import { CommonModule } from "@angular/common";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CmsConfig, ConfigModule, I18nModule } from "@spartacus/core";
import { NeedToGoBackModule } from "../shared/modules/need-to-go-back/need-to-go-back.module";
import { VaxContactUsComponent } from "./vax-contact-us/vax-contact-us.component";
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaService } from '../shared/services/recaptcha.service';

export function loadRecaptcha(recaptchaService: RecaptchaService): () => Promise<void> {
  return () => recaptchaService.loadRecaptchaConfig();
}

@NgModule({
  declarations: [VaxContactUsComponent],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    RouterModule,
    BrowserAnimationsModule,
    NeedToGoBackModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        VaxServeContactUsPageBodyComponent:{
          component:VaxContactUsComponent
        }

      },
    } as CmsConfig),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [RecaptchaService],
      useFactory: loadRecaptcha,
      multi: true,
    },
  ],
})
export class VaxAboutContactUsModule { }
